/**
 * Every English catalog, in one object — the shape a language pack is measured against.
 *
 * English is the only *complete* pack and this file is what makes that structural rather
 * than conventional: `Namespace` and `MessageKeys` are derived from this object in
 * `catalog.ts`, so a namespace added here is a namespace the type system immediately
 * demands everywhere, and a key removed here breaks the build at every call site that used
 * it. Adding a screen family is one line in this file and one file next to it — never an
 * edit in three places that drift apart.
 */

import { activityEn } from './activity';
import { appEn } from './app';
import { drawingEn } from './drawing';
import { drawingsEn } from './drawings';
import { entranceEn } from './entrance';
import { landingEn } from './landing';
import { legalEn } from './legal';
import { overviewEn } from './overview';
import { peopleEn } from './people';
import { profileEn } from './profile';
import { projectSetupEn } from './projectSetup';
import { projectSettingsEn } from './projectSettings';
import { projectsEn } from './projects';
import { registerEn } from './register';
import { reviewsEn } from './reviews';
import { roadmapEn } from './roadmap';
import { settingsEn } from './settings';
import { setupEn } from './setup';
import { shareEn } from './share';
import { inboxEn } from './inbox';
import { searchEn } from './search';
import { studioEn } from './studio';
import { tasksEn } from './tasks';
import { transmittalsEn } from './transmittals';

export const enCatalogs = {
  entrance: entranceEn,
  app: appEn,
  setup: setupEn,
  projects: projectsEn,
  people: peopleEn,
  profile: profileEn,
  inbox: inboxEn,
  search: searchEn,
  studio: studioEn,
  settings: settingsEn,
  share: shareEn,
  projectSetup: projectSetupEn,
  projectSettings: projectSettingsEn,
  register: registerEn,
  reviews: reviewsEn,
  roadmap: roadmapEn,
  activity: activityEn,
  overview: overviewEn,
  drawings: drawingsEn,
  drawing: drawingEn,
  landing: landingEn,
  legal: legalEn,
  tasks: tasksEn,
  transmittals: transmittalsEn,
} as const;
